import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackImageClick = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'image carousel',
        eventValue: slideIndex + 1
    });
};

export const trackNextImage = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'next image',
        eventValue: slideIndex + 1
    });
};

export const trackPreviousImage = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'previous image',
        eventValue: slideIndex + 1
    });
};

export const trackZoomImage = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'zoom',
        eventLabel: 'image gallery',
        eventValue: slideIndex + 1
    });
};

export const trackModalNextImage = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'next image gallery modal',
        eventValue: slideIndex + 1
    });
};

export const trackModalPreviousImage = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'previous image gallery modal',
        eventValue: slideIndex + 1
    });
};

export const trackModalZoomImage = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'zoom',
        eventLabel: 'image gallery modal',
        eventValue: slideIndex + 1
    });
};

export const trackModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'image gallery modal'
    });
};
